import React, { FC, PropsWithChildren, useEffect } from "react";

import log from "loglevel";

import * as globalLogger from "@/globalLogger";
import {
    NetworkError,
    NO_CONNECTION,
    TIME_ERROR,
    TimeError,
    TIMEOUT,
    TimeoutError,
    UnauthorizedError,
} from "@/shared/errors";

import { pubSub, TOPIC_ERROR, TOPIC_ERROR_DIALOG, TOPIC_TOKEN_EXPIRED, usePubSub } from "./shared/hooks";
import * as tagManager from "./tagManager";

window.addEventListener("unhandledrejection", (event) => {
    log.error("UNHANDLED REJECTION: ", event);
    pubSub.publish(TOPIC_ERROR, { error: event.reason });
    event.preventDefault();
    return undefined;
});

export const GlobalErrorHandler: FC<PropsWithChildren> = ({ children }) => {
    const { subscribe, publish } = usePubSub();
    useEffect(
        () => {
            // make sure we only subscribe once
            subscribe(TOPIC_ERROR, ({ error }) => {
                // log to the console
                log.error("ERROR: ", error);

                // Special handling for UnAuthorized
                if (error instanceof UnauthorizedError) {
                    globalLogger.logError(error.message, error); // Also log 401
                    if (error.message.startsWith("Token expired")) {
                        publish(TOPIC_TOKEN_EXPIRED, error.message);
                    } else {
                        publish(TOPIC_ERROR_DIALOG, {});
                    }
                    return;
                }

                // log to exception store
                globalLogger.logError(error.message, error);

                // push error to GA
                tagManager.pushErrorEvent(error);

                // Show error
                if (error instanceof TimeoutError) {
                    publish(TOPIC_ERROR_DIALOG, { errorCode: TIMEOUT });
                } else if (error instanceof NetworkError) {
                    publish(TOPIC_ERROR_DIALOG, { errorCode: NO_CONNECTION });
                } else if (error instanceof TimeError) {
                    publish(TOPIC_ERROR_DIALOG, { errorCode: TIME_ERROR });
                } else {
                    publish(TOPIC_ERROR_DIALOG, { errorCode: error.errorCode });
                }
            });
        },
        [] /* make sure we only subscribe once */,
    );

    return <>{children}</>;
};
